export enum RfidTagType {
  CLASSIC_EV1_1K = 'CLASSIC_EV1_1K',
  CLASSIC_EV1_4K = 'CLASSIC_EV1_4K',
  DESFire = 'DESFire',
  PLUS_EV1_2K = 'PLUS_EV1_2K',
  ULTRALIGHT_C = 'ULTRALIGHT_C',
  ULTRALIGHT_EV1 = 'ULTRALIGHT_EV1',
}
